import { Link } from 'react-router-dom';
// Styles
import './Navbar.css';
// Translate
import { useTranslation } from 'react-i18next';

const Navbar = ({ type }) => {
  const { t } = useTranslation();
  return (
    <nav className='navbar'>
      <ul>
        <li>
          <Link
            className={type === 'white' ? 'whiteText' : 'blackText'}
            to='/news'
          >
            {t('Global News')}
          </Link>
        </li>
        <li>
          <Link
            className={type === 'white' ? 'whiteText' : 'blackText'}
            to='/help'
          >
            {t('FAQs')}
          </Link>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
